define('featureflag',['edapUnderscore'], function(_) {
    'use strict';

    function FeatureFlag(edap, data) {
        var featureFlag = this,
            err;

        /**
         *  Validate
         */

        if (!edap || !edap.hasOwnProperty('edapVersion')) {
            throw new TypeError('FeatureFlag: must pass in EDAP when creating a new instance');
        }

        if (!(featureFlag instanceof FeatureFlag)) {
            err = new TypeError('FeatureFlag must be called with the "new" keyword');
            edap.error(err);
            throw err;
        }

        /**
         *  Sets all the FeatureFlag options from an object
         *
         *  @public
         *  @param {Object} [obj] - Object of values to set
         */
        featureFlag.setAll = function(obj) {
            var keys,
                i,
                len,
                e;

            if (typeof obj !== 'object') {
                e = new TypeError('featureFlag.set called without valid obj');
                edap.error(e);
                throw e;
            }

            keys = _.keys(featureFlag.internal);
            for (i = 0, len = keys.length; i < len; i++) {
                if (obj.hasOwnProperty(keys[i])) {
                    featureFlag.set(keys[i], obj[keys[i]]);
                }
            }
        };


        /**
         *  Sets key/value data
         *
         *  @public
         *  @param {String} [key] - Key name
         *  @param {Any} [value] - Value to assign to the key
         */
        featureFlag.set = function(key, value) {
            if (featureFlag.internal.hasOwnProperty(key)) {
                featureFlag.internal[key] = value;
            }
        };


        /**
         *  Gets the cloned value of a single key or returns the cloned data object
         *
         *  @public
         *  @param {String} [optKey] - Optional key name to return its value
         *  @returns {Object} - If optKey is passed and it is a data key then the cloned value is returned.
         *                      If optKey is passed and it is not a valid key then null is returned.
         *                      If optKey is not passed then the entire cloned data object is returned.
         */
        featureFlag.get = function(optKey) {
            if (typeof optKey === 'string') {
                if (featureFlag.internal.hasOwnProperty(optKey)) {
                    return _.clone(featureFlag.internal[optKey], true);
                }
            } else {
                // Do a deep clone so that payload is cloned
                return _.clone(featureFlag.internal, true);
            }

            return null;
        };


        /**
         *  Constructor
         */

        // Set the default
        featureFlag.internal = {
            name: null,
            value: null,
            payload: {}
        };

        if (data) {
            featureFlag.setAll(data);
        }

        return featureFlag;
    }

    return FeatureFlag;
});

